import { Goerli, Sepolia } from "@usedapp/core";

export const ROUTER_ADDRESS = "0x95F671B7dDc26fd4D8d10f88F254a1e7A2000385"; 

export const DAPP_CONFIG = {
  readOnlyChainId: Sepolia.chainId,
  readOnlyUrls: {
    [Sepolia.chainId]: "https://eth-sepolia.g.alchemy.com/v2/0Y1hkMk0E1jU_w045unYUR3R4kOU5zw0",
  },
};